<script lang="ts" setup>
defineSlots<{
  default: () => VNode[];
}>();
</script>

<template>
  <div class="contentGroup">
    <slot />
  </div>
</template>

<style lang="scss">
.contentGroup {
  margin-bottom: 40px;

  & > * {
    margin-bottom: 0 !important;
  }
}
</style>
